
import { map, take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { clone, each } from 'lodash';

import { superSessionStorage } from '~common/app/shared/utils/session-storage';

import { settings } from '../../app.settings';
import { BaseService } from '~common/app/shared/services/base.service';
import { Store, toApi, fromApi } from '../../shared/models/store';
import { NaiveParameterCodec } from '~common/app/shared/utils/encoding';

const API_PATH = settings.api.url + '/stores';
const API_PATH_SIRET = settings.api.url + '/sirets';

@Injectable()
export class StoreService extends BaseService {
  kept: any = superSessionStorage.get('siret') || {};

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  fetch(params = {}): Observable<any> {
    let apiParams = new HttpParams({ encoder: new NaiveParameterCodec() });

    each(params, (value: any, key) => {
      if (key === 'filters') {
        if (value.term) {
          apiParams = apiParams.append('keyword', value.term);
        }
      } else if (value || value === 0) {
        apiParams = apiParams.append(key, value);
      }
    });

    return this.http.get(API_PATH, {
      params: apiParams
    }).pipe(map((response) => {
      return this.hydrate(Store, response);
    }));
  }

  get(id): Observable<any > {
    return this.http.get(API_PATH + '/' + id).pipe(map(response => {
      response = fromApi(response);

      return this.hydrate(Store, response);
    }));
  }

  create(data): Observable<any> {
    return this.http.post(API_PATH, toApi(data));
  }

  update(id, data): Observable<any> {
    return this.http.put(API_PATH + '/' + id, toApi(data));
  }

  delete(id): Observable<any> {
    return this.http.delete(API_PATH + '/' + id);
  }

  save(data) {
    if (data.id) {
      return this.update(data.id, data);
    } else {
      return this.create(data);
    }
  }

  fetchAffiliate(id) {
    return this.http.get(API_PATH_SIRET + '/' + id);
  }

  searchBySiret(siret) {
    siret = siret.replace(/\D/g, '');

    const params = new HttpParams().set('siret', siret);

    return this.http.get(API_PATH_SIRET, {
      params
    }).pipe(map((response) => {
      let shop;

      if (response['items'][0]) {
        shop = response['items'][0];
        shop['country']   = shop['country'] || 'FR';
        shop['latitude']  = +shop['latitude'];
        shop['longitude'] = +shop['longitude'];
      }

      return shop;
    }));
  }

  keepStore(store) {
    store = clone(store);

    if (!store) {
      this.kept = {};
    } else {
      this.kept[store.siret] = store;
    }

    superSessionStorage.set('siret', store);
  }

  restoreStore(siret) {
    return this.kept[siret];
  }

  upload(file: File, params = {}) {
    const formData = new FormData();
    formData.append('file', file);

    Object.keys(params).forEach((key) => {
      formData.append(key, params[key]);
    });

    return this.http.post(API_PATH + '/import', formData);
  }

  fetchDelegatedStores(params = {}): Observable<any> {
    let apiParams = new HttpParams({ encoder: new NaiveParameterCodec() });

    each(params, (value: any, key) => {
      if (key === 'filters') {
        if (value.term) {
          apiParams = apiParams.append('keyword', value.term );
        }
      } else if (value || value === 0) {
        apiParams = apiParams.append(key, value);
      }
    });

    return this.http.get(API_PATH, {
      params: apiParams
    }).pipe(map((response) => {
      return this.hydrate(Store, response);
    }));
  }
}
